import Date from 'cccisd-survey-date';
import Player from './Player';

Date.player = Player;
Date.code = 'invisibleDate';
Date.name = 'Invisible Date';

export default Date;
